document.addEventListener("shopify:section:load", () => {
  attachFaqDropdowns();
});

document.addEventListener("shopify:block:select", () => {
  attachFaqDropdowns();
});

function attachFaqDropdowns() {
  document.querySelectorAll(".faq-question").forEach(function (question) {
    question.removeEventListener("click", toggleFaq); // prevent duplicates
    question.addEventListener("click", toggleFaq);
  });
}

function toggleFaq(event) {
  const answer = event.target.nextElementSibling;
  answer.classList.toggle("active");
}